import React from 'react';

const PaymentinProgressIcon = () => {
  return (
    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="64" height="64" rx="32" fill="#FFFAF0" />
      <path
        d="M32 28V34.6667"
        stroke="#CA8000"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.0006 44.547H23.9206C19.2939 44.547 17.3606 41.2404 19.6006 37.2004L23.7606 29.707L27.6806 22.667C30.0539 18.387 33.9472 18.387 36.3206 22.667L40.2406 29.7204L44.4006 37.2137C46.6406 41.2537 44.6939 44.5604 40.0806 44.5604H32.0006V44.547Z"
        stroke="#CA8000"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.9922 38.667H32.0042"
        stroke="#CA8000"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PaymentinProgressIcon;
